import { DYNAMIC_FEATURE_TOGGLES } from './types';

type Mixpanel = {
  flags: {
    flags: Map<string, unknown>;
    get_variant_value_sync: (key: string) => string | undefined;
  };
};

declare global {
  interface Window {
    mixpanelFeatureFlags?: ((mixpanel: Mixpanel) => void)[];
  }
}

const isDynamicFeatureToggle = (key: string) =>
  (DYNAMIC_FEATURE_TOGGLES as readonly string[]).includes(key);

/**
 * The GTM tag `Mixpanel - Feature Flag - Bootstrap` calls every callback in
 * `window.mixpanelFeatureFlags` when Mixpanel loads or updates the flags. A flag
 * whose key is a dynamic feature toggle sets that toggle: on for any variant
 * except `control`.
 */
export const registerMixpanelFeatureFlags = () => {
  window.mixpanelFeatureFlags = window.mixpanelFeatureFlags || [];
  window.mixpanelFeatureFlags.push(mixpanel => {
    mixpanel.flags.flags.forEach((_flag, key) => {
      if (!isDynamicFeatureToggle(key)) {
        return;
      }

      // Reading the variant through Mixpanel sends the $experiment_started event.
      const variant = mixpanel.flags.get_variant_value_sync(key);
      window.featureToggles.push([
        key,
        variant !== undefined && variant !== 'control',
      ]);
    });
  });
};
